"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customStyles = exports.StyledMenu = exports.SmallOption = exports.OptionLinked = exports.Option = exports.MenuList = exports.Menu = exports.DropdownIndicator = exports.Control = exports.Container = exports.ClearIndicator = void 0;

var _checkGreen = _interopRequireDefault(require("@r1-frontend/ui-react/assets/img/check-green.svg"));

var _button = _interopRequireDefault(require("@r1-frontend/ui-react/components/buttons/button"));

var _arrows = require("@r1-frontend/ui-react/components/svg/arrows");

var _boxShadow = require("@r1-frontend/ui-react/tokens/boxShadow");

var _colors = require("@r1-frontend/ui-react/tokens/colors");

var _fonts = require("@r1-frontend/ui-react/tokens/fonts");

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["children"],
    _excluded2 = ["innerRef", "innerProps"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var fadeIn = (0, _styledComponents.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n    transform: translateY(-16px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"])));
/**
 * Добавочный элемент. Костыль для устранения обрезки тени, когда у родительского компонента overflow: hidden
 * Добавляется невидимый элемент под тенью списка, подымая край тени чуть выше
 */

var getBottomElement = function getBottomElement() {
  return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    &::after {\n      content: \"\";\n      position: absolute;\n      bottom: -25px;\n      width: 100%;\n      height: 1px;\n      background-color: transparent;\n      z-index: 1;\n    }\n  "])));
};

var StyledMenu = (0, _styledComponents["default"])(_reactSelect.components.Menu).withConfig({
  displayName: "dropdown__StyledMenu",
  componentId: "sc-1vzw4hz-0"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  margin: 0 !important;\n  top: calc(100% + 10px) !important;\n  left: 0;\n  box-shadow: ", " !important;\n  border-radius: 16px !important;\n  animation: ", " 0.2s ease-in-out;\n  z-index: 10000 !important;\n\n  ", ";\n"])), _boxShadow.BoxShadow.M, fadeIn, function (p) {
  var _p$selectProps;

  return ((_p$selectProps = p.selectProps) === null || _p$selectProps === void 0 ? void 0 : _p$selectProps.addBottomElement) && getBottomElement();
});
exports.StyledMenu = StyledMenu;

var Menu = function Menu(props) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(StyledMenu, _extends({
    "data-test": "select-menu"
  }, rest), children);
};

exports.Menu = Menu;

var BtnWrapper = _styledComponents["default"].div.withConfig({
  displayName: "dropdown__BtnWrapper",
  componentId: "sc-1vzw4hz-1"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 16px 30px 16px 20px;\n"])));

var MenuListStyled = _styledComponents["default"].div.withConfig({
  displayName: "dropdown__MenuListStyled",
  componentId: "sc-1vzw4hz-2"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  border-radius: 16px;\n  padding: 0;\n  max-height: ", ";\n  overflow-y: auto;\n  overflow-x: hidden;\n  position: relative;\n  -webkit-overflow-scrolling: touch;\n  box-sizing: border-box;\n"])), function (props) {
  if (!props.maxHeight) {
    return '300px';
  }

  return props.maxHeight + 'px';
});

var MenuList = function MenuList(props) {
  var children = props.children,
      innerRef = props.innerRef,
      _props$selectProps = props.selectProps,
      btnProps = _props$selectProps.btnProps,
      maxHeight = _props$selectProps.maxHeight;
  return /*#__PURE__*/_react["default"].createElement(MenuListStyled, {
    "data-test": "select-menuList",
    ref: innerRef,
    maxHeight: maxHeight
  }, children, !!btnProps && /*#__PURE__*/_react["default"].createElement(BtnWrapper, null, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    bType: "secondary",
    size: "small",
    onClick: btnProps.onClick,
    disabled: btnProps.isDisable
  }, btnProps.btnText)));
};

exports.MenuList = MenuList;

var StyledOption = _styledComponents["default"].div.withConfig({
  displayName: "dropdown__StyledOption",
  componentId: "sc-1vzw4hz-3"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 100%;\n  min-height: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: ", ";\n  ", ";\n  color: ", ";\n  padding: 8px 30px 8px 20px;\n  transition: background-color linear .2s;\n  cursor: pointer;\n  text-align: left;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.smallOption ? '36px' : '48px';
}, _colors.COLORS.BgMain, _fonts.FONTS.XS, _colors.COLORS.TextPrimary, _colors.COLORS.BgSecondary);

var StyledOptionSmall = _styledComponents["default"].div.withConfig({
  displayName: "dropdown__StyledOptionSmall",
  componentId: "sc-1vzw4hz-4"
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  min-height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: ", ";\n  ", ";\n  color: ", ";\n  padding: 6px 20px 6px 10px;\n  transition: background-color linear .2s;\n  cursor: pointer;\n  text-align: left;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  @media (max-width: 1000px) {\n    min-height: 28px;\n    padding: 4px 20px 4px 10px;\n  }\n"])), _colors.COLORS.BgMain, _fonts.FONTS.XS, _colors.COLORS.TextPrimary, _colors.COLORS.BgSecondary);

var StyledIcon = _styledComponents["default"].img.withConfig({
  displayName: "dropdown__StyledIcon",
  componentId: "sc-1vzw4hz-5"
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 20px;\n  position: absolute;\n  right: 16px;\n"])));

var StyledOptionLinked = _styledComponents["default"].a.withConfig({
  displayName: "dropdown__StyledOptionLinked",
  componentId: "sc-1vzw4hz-6"
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  text-decoration: none;\n  width: 100%;\n  min-height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: ", ";\n  ", ";\n  color: ", ";\n  padding: 8px 30px 8px 20px;\n  transition: background-color linear .2s;\n  cursor: pointer;\n  text-align: left;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), _colors.COLORS.BgMain, _fonts.FONTS.XS, _colors.COLORS.TextPrimary, _colors.COLORS.BgSecondary);

var OptionLinked = function OptionLinked(props) {
  var children = props.children,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  var path = props.data.path ? props.data.path : './';
  return /*#__PURE__*/_react["default"].createElement(StyledOptionLinked, _extends({
    href: path,
    ref: innerRef,
    isFocused: isFocused,
    isSelected: isSelected,
    isDisabled: isDisabled
  }, innerProps), children, isSelected && /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    src: _checkGreen["default"],
    alt: "check"
  }));
};

exports.OptionLinked = OptionLinked;

var Option = function Option(props) {
  var children = props.children,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      smallOption = props.smallOption;
  return /*#__PURE__*/_react["default"].createElement(StyledOption, _extends({
    smallOption: smallOption,
    ref: innerRef,
    isFocused: isFocused,
    isSelected: isSelected,
    isDisabled: isDisabled
  }, innerProps), children, isSelected && /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    src: _checkGreen["default"],
    alt: "check"
  }));
};

exports.Option = Option;

var SmallOption = function SmallOption(props) {
  var children = props.children,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return /*#__PURE__*/_react["default"].createElement(StyledOptionSmall, _extends({
    ref: innerRef,
    isFocused: isFocused,
    isSelected: isSelected,
    isDisabled: isDisabled
  }, innerProps), children, isSelected && /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    src: _checkGreen["default"],
    alt: "check"
  }));
};

exports.SmallOption = SmallOption;

var ControlDiv = _styledComponents["default"].div.withConfig({
  displayName: "dropdown__ControlDiv",
  componentId: "sc-1vzw4hz-7"
})(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 100px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  ", ";\n\n  border: 2px solid ", ";\n  \n  border-radius: 16px;\n  transition: border-color linear .1s;\n  \n  background-color: ", ";\n\n  cursor: pointer;\n  transition: all 0.2s linear;\n\n  &:hover {\n    border-color: ", ";\n  }\n"])), _fonts.FONTS.XS, function (props) {
  if (props.menuIsOpen) {
    return _colors.COLORS.Control;
  }

  return props.isFocused ? _colors.COLORS.GRAY_LIGHT : _colors.COLORS.BgSecondary;
}, function (props) {
  if (props.isDisabled) {
    return _colors.COLORS.BgSecondary;
  }

  return _colors.COLORS.BgMain;
}, function (props) {
  return props.menuIsOpen ? _colors.COLORS.GRAY_DARK : _colors.COLORS.GRAY_LIGHT;
});

var Control = function Control(_ref) {
  var innerRef = _ref.innerRef,
      innerProps = _ref.innerProps,
      rest = _objectWithoutProperties(_ref, _excluded2);

  delete rest['cx'];
  return /*#__PURE__*/_react["default"].createElement(ControlDiv, _extends({
    ref: innerRef
  }, innerProps, rest));
};

exports.Control = Control;

var Container = _styledComponents["default"].div.withConfig({
  displayName: "dropdown__Container",
  componentId: "sc-1vzw4hz-8"
})(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  width: ", ";\n  display: block;\n\n  ", "\n"])), function (props) {
  return props.width || '100%';
}, function (props) {
  return !props.isSearchable && (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    input {\n      user-select: none;\n    }\n  "])));
});

exports.Container = Container;

var Icon = _styledComponents["default"].span.withConfig({
  displayName: "dropdown__Icon",
  componentId: "sc-1vzw4hz-9"
})(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  background: url(\"", "\") 50% 50% no-repeat;\n  width: ", "px;\n  height: ", "px;\n\n  ", "\n"])), function (_ref2) {
  var path = _ref2.path;
  return path;
}, function (_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 0 : _ref3$size;
  return size;
}, function (_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 0 : _ref4$size;
  return size;
}, function (props) {
  return props.isOpen && (0, _styledComponents.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["transform: rotate(180deg); transition: 0.30s;"])));
});

var IconWrap = _styledComponents["default"].div.withConfig({
  displayName: "dropdown__IconWrap",
  componentId: "sc-1vzw4hz-10"
})(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n\n  ", "\n"])), function (_ref5) {
  var _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 24 : _ref5$size;
  return size;
}, function (_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? 24 : _ref6$size;
  return size;
}, function (props) {
  return props.isOpen && (0, _styledComponents.css)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["transform: rotate(180deg); transition: 0.30s;"])));
});

var Indicator = (0, _styledComponents["default"])(_reactSelect.components.DropdownIndicator).withConfig({
  displayName: "dropdown__Indicator",
  componentId: "sc-1vzw4hz-11"
})(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  width: 17px;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  margin-right: 20px;\n  padding: 0 !important;\n"])));
var Clear = (0, _styledComponents["default"])(_reactSelect.components.ClearIndicator).withConfig({
  displayName: "dropdown__Clear",
  componentId: "sc-1vzw4hz-12"
})(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  width: 17px;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  margin-right: 20px;\n  padding: 0 !important;\n"])));

var DropdownIndicator = function DropdownIndicator(props) {
  var _props$selectProps2;

  var isOpen = props === null || props === void 0 ? void 0 : (_props$selectProps2 = props.selectProps) === null || _props$selectProps2 === void 0 ? void 0 : _props$selectProps2.menuIsOpen;
  return /*#__PURE__*/_react["default"].createElement(Indicator, props, /*#__PURE__*/_react["default"].createElement(IconWrap, {
    isOpen: isOpen
  }, /*#__PURE__*/_react["default"].createElement(_arrows.SingleArrowDown, null)));
};

exports.DropdownIndicator = DropdownIndicator;

var ClearIndicator = function ClearIndicator(props) {
  var _props$selectProps3;

  var isOpen = props === null || props === void 0 ? void 0 : (_props$selectProps3 = props.selectProps) === null || _props$selectProps3 === void 0 ? void 0 : _props$selectProps3.menuIsOpen;
  var color = isOpen ? _colors.COLORS.TextWhite : _colors.COLORS.TextPrimary;
  return /*#__PURE__*/_react["default"].createElement(Clear, props, /*#__PURE__*/_react["default"].createElement(Icon, {
    size: "14",
    path: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 26' style='fill:none;stroke:%23".concat(color.slice(1, 7), ";stroke-linecap:round;'%3E%3Cpath d='M1 1l24 24M25 1L1 25'/%3E%3C/svg%3E"),
    isOpen: isOpen
  }));
};

exports.ClearIndicator = ClearIndicator;
var customStyles = {
  valueContainer: function valueContainer(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      padding: '2px 16px'
    });
  },
  noOptionsMessage: function noOptionsMessage(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      font: 'var(--regular-xs)',
      color: _colors.COLORS.TextDisabled,
      textAlign: 'left',
      padding: '8px 30px 8px 20px'
    });
  },
  loadingMessage: function loadingMessage(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      font: 'var(--regular-xs)',
      color: _colors.COLORS.TextDisabled
    });
  },
  placeholder: function placeholder(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      color: _colors.COLORS.TextDisabled
    });
  },
  input: function input(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      color: _colors.COLORS.TextPrimary
    });
  },
  singleValue: function singleValue(provided, state) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      color: state.selectProps.menuIsOpen ? _colors.COLORS.TextWhite : _colors.COLORS.TextPrimary
    });
  }
};
exports.customStyles = customStyles;